module.exports = require('./abstract-annual-report').extend({ })
